import { render } from "./ContactEditor.vue?vue&type=template&id=bd866058&scoped=true"
import script from "./ContactEditor.vue?vue&type=script&lang=ts"
export * from "./ContactEditor.vue?vue&type=script&lang=ts"

import "./ContactEditor.vue?vue&type=style&index=0&id=bd866058&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bd866058"

export default script